import { post, get } from "@/request/http";

//  获取显示数据
export const getNoticeList = p => get("/center/getNoticeList", p);


// 修改排序
export const updateNewsSort = p => get("/center/updateNewsSort", p);

//添加公告
export const saveNotice = p => get("/center/saveNotice", p);

//删除公告
export const deleteNotice = p => get("/center/deleteNotice", p);

//获取公告信息
export const getNoticeInfo = p => get("/center/getNoticeInfo", p);

//更新公告
export const updateNotice = p => post("/center/updateNotice", p);
